var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import APButton from '../../common/APButton';
import KYCConfirmLevelModal from '../../KYC/KYCConfirmLevelModal';
import KYCMitekComponent from '../KYCMitek';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import { setDropdownsDefaultValue } from '../../../helpers/kycFormHelper';
import { renderFormInputs } from '../../../helpers/formGeneratorHelper';
import { submitIdentityMindForm } from '../KYC_IMLegacyHelpers';
import { kycConfigLevelShape } from '../../../propTypes/kycConfigShapePropTypes';
var slidePaneClasses = getBEMClasses('slide-pane');
var KYC_IMLegacyFormComponent = function (_React$Component) {
  _inherits(KYC_IMLegacyFormComponent, _React$Component);
  function KYC_IMLegacyFormComponent(props) {
    _classCallCheck(this, KYC_IMLegacyFormComponent);
    var _this = _possibleConstructorReturn(this, (KYC_IMLegacyFormComponent.__proto__ || Object.getPrototypeOf(KYC_IMLegacyFormComponent)).call(this, props));
    _this.openModal = function (isOpen) {
      return _this.setState({
        isOpen: isOpen
      });
    };
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _createClass(KYC_IMLegacyFormComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      setDropdownsDefaultValue(this.props.level.sections, this.props.change);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var context = this.context;
      var _props = this.props,
        level = _props.level,
        processing = _props.processing,
        formValues = _props.formValues,
        invalid = _props.invalid,
        customClass = _props.customClass,
        logout = _props.logout,
        showCancelButton = _props.showCancelButton;
      var isLevel1 = level.level < 2;
      var baseClasses = getBEMClasses('kyc-form', customClass || '');
      return React.createElement(React.Fragment, null, React.createElement('form', {
        className: slidePaneClasses('body')
      }, React.createElement('div', {
        className: baseClasses('form-body')
      }, React.createElement('div', {
        className: baseClasses('title')
      }, context.t('Complete this form to verify your account to raise your limits and enable buys.')), level && level.sections.map(function (section, idx) {
        return React.createElement('div', {
          className: baseClasses('section'),
          key: idx
        }, React.createElement('header', {
          className: baseClasses('section-header')
        }, context.t(section.label)), React.createElement('div', {
          className: baseClasses('section-body')
        }, isLevel1 ? renderFormInputs(section.form, baseClasses(), context) : React.createElement(KYCMitekComponent, _this2.props)));
      }), isLevel1 && React.createElement('div', {
        className: baseClasses('section', 'bottom')
      }, React.createElement(APButton, {
        type: 'button',
        customClass: baseClasses(),
        disabled: invalid,
        onClick: function onClick() {
          return _this2.openModal(true);
        }
      }, context.t('Submit')), showCancelButton && React.createElement(APButton, {
        type: 'button',
        customClass: baseClasses(),
        onClick: logout
      }, context.t('Cancel'))))), isLevel1 && React.createElement(KYCConfirmLevelModal, {
        isOpen: this.state.isOpen,
        close: function close() {
          return _this2.openModal(false);
        },
        onConfirm: function onConfirm() {
          return submitIdentityMindForm(_this2.props);
        },
        processing: processing,
        level: level,
        values: formValues
      }));
    }
  }]);
  return KYC_IMLegacyFormComponent;
}(React.Component);
KYC_IMLegacyFormComponent.propTypes = {
  kycConfig: PropTypes.shape({
    type: PropTypes.string,
    levels: PropTypes.arrayOf(PropTypes.shape(kycConfigLevelShape))
  })
};
KYC_IMLegacyFormComponent.defaultProps = {
  showCancelButton: false
};
KYC_IMLegacyFormComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default KYC_IMLegacyFormComponent;